package com.havn.app.features.notifications.platform

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

actual object HavnPushNotifications {
    private val _deepLinks = MutableStateFlow<String?>(null)
    actual val deepLinks: StateFlow<String?> = _deepLinks.asStateFlow()

    actual suspend fun requestPermissionAndToken(): Result<HavnPushRegistration?> = Result.success(null)

    actual fun consumePendingDeepLink(): String? = null
}
